module.exports = __webpack_public_path__ + "img/img3.e6471ee5.png";